import { Action } from 'react-sweet-state';

import { PricingPeriod, FormattedPriceCalculationResponse, CurrencyISOCode } from '../constants';

import { PriceFinderState } from './store';

export const updateUnitCount =
	(unitCount: number): Action<PriceFinderState> =>
	({ setState }) => {
		setState({
			unitCount,
		});
	};

export const updateBillingCycle =
	(billingCycle: PricingPeriod): Action<PriceFinderState> =>
	({ setState }) => {
		setState({
			billingCycle,
		});
	};

export const updatePriceCalcs =
	(priceCalcs: FormattedPriceCalculationResponse[]): Action<PriceFinderState> =>
	({ setState }) => {
		setState({
			priceCalcs,
		});
	};

export const updateCurrencyISOCode =
	(currencyISOCode: CurrencyISOCode): Action<PriceFinderState> =>
	({ setState }) => {
		setState({
			currencyISOCode,
		});
	};
